import React, { useEffect, useRef, useState } from "react";
import { Slide, Stack, Typography, useTheme } from "@mui/material";
import { User } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
  AvatarContainer,
  Container,
  MessageBox,
  MessageContainer,
  WelcomeMessageContainer,
} from "@components/ChatAgent/components/ChatAgentMessageBox/style";
import {
  AgentOption,
  AgentOptionsRow,
} from "@components/ChatAgent/components/ChatAgentAgentSelector/style";
import { AgentType } from "@hooks/useChatAgent";

interface ChatAgentAgentSelectorProps {
  // null = nessuna scelta fatta, mostriamo le pillole;
  // valorizzato = mostriamo l'opzione utente con la scelta dell'agente.
  selectedType: AgentType | null;
  onSelect: (type: AgentType) => void;
  disabled?: boolean;
}

const ChatAgentAgentSelector: React.FC<ChatAgentAgentSelectorProps> = ({
  selectedType,
  onSelect,
  disabled,
}) => {
  const theme = useTheme();
  const { t } = useTranslation("agent_chat");
  const [isDebouncing, setIsDebouncing] = useState(false);
  const debounceTimerRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => () => clearTimeout(debounceTimerRef.current), []);

  const handleSelect = (type: AgentType) => {
    if (isDebouncing || disabled) return;
    setIsDebouncing(true);
    onSelect(type);
    debounceTimerRef.current = setTimeout(() => setIsDebouncing(false), 800);
  };

  const selectedLabel = selectedType
    ? selectedType === "support"
      ? t("agentTypeSupport")
      : t("agentTypeAdmin")
    : null;

  return (
    <>
      {!selectedLabel ? (
        <Slide
          direction="up"
          in
          mountOnEnter
          unmountOnExit
          style={{
            height: "100%",
          }}
        >
          <Stack>
            {!selectedLabel && (
              <WelcomeMessageContainer
                gap={"20px"}
                height={!selectedLabel ? "100%" : "unset"}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
              >
                <Typography textAlign="center" fontSize="1.25rem">
                  {t("agentSelectorPrompt")}
                </Typography>
                <AgentOptionsRow>
                  <AgentOption
                    variant="outlined"
              disabled={disabled || isDebouncing}
              onClick={() => handleSelect("support")}
                  >
                    {t("agentTypeSupport")}
                  </AgentOption>
                  <AgentOption
                    variant="outlined"
              disabled={disabled || isDebouncing}
              onClick={() => handleSelect("admin")}
                  >
                    {t("agentTypeAdmin")}
                  </AgentOption>
                </AgentOptionsRow>
              </WelcomeMessageContainer>
            )}
          </Stack>
        </Slide>
      ) : (
        <Container
          isAI={false}
          messageIndex={1}
          gap={"10px"}
          sx={{ marginTop: "10px" }}
        >
          <AvatarContainer isAI={false}>
            <User size={20} color="#fff" />
          </AvatarContainer>
          <MessageContainer theme={theme} isAI={false}>
            <MessageBox isAI={false}>{selectedLabel}</MessageBox>
          </MessageContainer>
        </Container>
      )}
    </>
  );
};

export default ChatAgentAgentSelector;
